<template>
  <b-card no-body class="mt-6">
    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light table-th-color table-textcenter"
      :data="get_AllhomeBanner"
      border
    >
      <el-table-column label="Name" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.heading }}
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Date" prop="title" sortable>
        <template v-slot="{ row }" class="">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{
              new Date(row.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
              })
            }}
            <!-- {{ row.createdAt }} -->
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="40px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
// import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "element-ui";

import { mapState } from "vuex";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 8,
      dummyData: [
        {
          title: "hello",
          date: "2022-05-23T06:54:54.830Z",
        },
      ],
    };
  },

  methods: {
    async function() {
      this.$store.dispatch("services/getallhomebanner");
    },
    handleView(slot) {
      const { row } = slot;
      this.$router.push({
        name: "blogspage",
        params: { id: row._id, slug: this.toKebabCase(row.title) },
      });
    },

    async handleEdit(scope) {
      let { row } = scope;
      // console.log(row);
      await this.$store.commit("services/SELECT_Bannerhome", row);

      this.$router.push({ name: "editannouncement" });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { _id: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("services/deletehomebanner", payload);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
    },
  },
  computed: {
    ...mapState("services", { get_AllhomeBanner: "get_AllhomeBanner" }),

    displayedPages() {
      return this.get_AllhomeBanner.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    totalPages() {
      return this.get_AllhomeBanner.length;
    },
  },
  mounted() {
    this.function();
  },
};
</script>

<style scoped>
.clr606266 {
  color: #606266;
}
</style>
